.mainLogo {
  color: inherit;
  text-decoration: none;
  margin-right: 14px;
  display: flex;
  align-items: center;
}
